import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-1",
  "use": "menu-1-usage",
  "viewBox": "0 0 20 19.48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 19.48\" id=\"menu-1\"><title>menu-1</title><path d=\"M9.82 7.26a4 4 0 0 1-1.32-.2L1.17 4.35c-.6-.22-.69-.55-.69-.72s.09-.5.69-.72L8.5.21A4 4 0 0 1 9.82 0a4 4 0 0 1 1.32.2l7.33 2.71c.6.22.69.55.69.72s-.09.5-.69.72l-7.33 2.71a4 4 0 0 1-1.32.2zM8.25 19.48a1.48 1.48 0 0 1-.52-.1l-6.41-2.45a2.23 2.23 0 0 1-1.32-2V6.74c0-.73.39-1.21 1-1.21a1.39 1.39 0 0 1 .49.1L8 8.07a2.31 2.31 0 0 1 1.41 2v8.17a1.15 1.15 0 0 1-1.16 1.21zm3.29-.14c-.61 0-1-.35-1-1.07V10.1a2.2 2.2 0 0 1 1.29-2l6.41-2.45a1.66 1.66 0 0 1 .55-.1A1.15 1.15 0 0 1 20 6.74v8.17a2.33 2.33 0 0 1-1.43 2l-6.51 2.38a1.44 1.44 0 0 1-.52 0zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-1.svg
// module id = fcpi
// module chunks = 6